import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';

class Form extends React.Component {

    render(props) {
      return (
        <table>
          <thead>
            <th>column 1</th>
            <th>column 2</th>
            <th>column 3</th>
          </thead>
          <tbody>
            <tr>
              <td>data 1</td>
              <td>data 2</td>
              <td>data 3</td>
            </tr>
          </tbody>
        </table>
      );
    }
  }
  


      export default  function PrintForm (props) {
        const componentRef = useRef();
        const handlePrint = useReactToPrint({
            content: () => componentRef.current,
          });
        return (
            <div>
              
              <Form ref={componentRef}  data = {props}/>
              <button onClick={handlePrint}>Print this out!</button>
            </div>
          );


      }
